import { useRef, useState } from 'react'

import CheckCircleOutlinedIcon from '@ant-design/icons/CheckCircleOutlined'
import CloseCircleOutlinedIcon from '@ant-design/icons/CloseCircleOutlined'
import DeleteOutlinedIcon from '@ant-design/icons/DeleteOutlined'
import DownOutlinedIcon from '@ant-design/icons/DownOutlined'

import Button from '@mui/material/Button'
import ButtonGroup from '@mui/material/ButtonGroup'
import ClickAwayListener from '@mui/material/ClickAwayListener'
import Grow from '@mui/material/Grow'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import MenuItem from '@mui/material/MenuItem'
import MenuList from '@mui/material/MenuList'
import Paper from '@mui/material/Paper'
import Popper from '@mui/material/Popper'

import { RoleGuard } from '@shared/providers/src/MeProvider'
import { UserRole } from '@shared/utils'

export function CBOStatus({ status, onSelect }) {
  const anchorRef = useRef(null)
  const [open, setOpen] = useState(false)

  const handleClose = () => setOpen(false)

  const handleNewStatus = (newStatus) => {
    onSelect(newStatus)
    handleClose()
  }

  return (
    <>
      <ButtonGroup ref={anchorRef} color={statusToColor[status]} variant="outlined">
        <Button startIcon={statusToIcon[status]}>{statusToLabel[status]}</Button>
        {onSelect && (
          <RoleGuard allowed={[UserRole.Admin]}>
            <Button onClick={() => setOpen((o) => !o)}>
              <DownOutlinedIcon />
            </Button>
          </RoleGuard>
        )}
      </ButtonGroup>
      {onSelect && (
        <Popper open={open} anchorEl={anchorRef.current} role={undefined} transition disablePortal sx={{ zIndex: 1 }}>
          {({ TransitionProps, placement }) => (
            <Grow
              {...TransitionProps}
              style={{
                transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom',
              }}
            >
              <Paper>
                <ClickAwayListener onClickAway={handleClose}>
                  <MenuList id="split-button-menu" autoFocusItem>
                    {['active', 'archived', 'deleted'].map((v) => (
                      <MenuItem key={v} disabled={status === v} selected={status === v} onClick={() => handleNewStatus(v)}>
                        <ListItemIcon>{statusToIcon[v]}</ListItemIcon>
                        <ListItemText>{statusToLabel[v]}</ListItemText>
                      </MenuItem>
                    ))}
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>
      )}
    </>
  )
}

export const statusToLabel = {
  active: 'Active',
  archived: 'Disabled',
  deleted: 'Deleted',
}

const statusToColor = {
  active: 'success',
  archived: 'secondary',
  deleted: 'error',
}

const statusToIcon = {
  active: <CheckCircleOutlinedIcon />,
  archived: <CloseCircleOutlinedIcon />,
  deleted: <DeleteOutlinedIcon />,
}
